import React from "react";
import classes from "./styles.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

export default function Pagination({
  currentPage,
  totalPages,
  handlePrevPage,
  handleNextPage,
}) {
  return (
    <div className={classes.Pagination}>
      <button
        onClick={() => handlePrevPage(currentPage, totalPages)}
        disabled={currentPage === 1}
      >
        <FontAwesomeIcon icon={faChevronLeft} size="sm" />
        Previous
      </button>
      <span>
        <strong>{currentPage}</strong> of {totalPages}
      </span>
      <button
        onClick={() => handleNextPage(currentPage, totalPages)}
        disabled={currentPage === totalPages}
      >
        Next
        <FontAwesomeIcon icon={faChevronRight} size="sm" />
      </button>
    </div>
  );
}
